import { BaseModel } from "../base.model";

export interface Publisher extends BaseModel {
  avatar?: any;
  code?: string;
  name?: string
}

export const defaultPublisher: Readonly<Publisher> = {};